import { z } from 'zod';

// DSGVO: one deletion per media message. phoneNumberId comes from the saga ChatLinks watermark (originally the Chat aggregate snapshot from Chat_Created).
export const schemaChatMediaDeletionRequestedPayload = z.object({
    mediaKey: z.string().min(1),
    metaMediaId: z.string().min(1),
    phoneNumberId: z.string().min(1),
});

export type Schema_ChatMediaDeletionRequestedPayload = z.infer<typeof schemaChatMediaDeletionRequestedPayload>;
